import type { KeyData } from '@/components/Chart/types/chartData';

export const getSeriesId = (key: KeyData, field: string, transactionDate?: string): string => {
  const baseId = `${key.Code}-${key.TimeRef}-${key.Period}-${key.PeriodType}-${field}`;
  return transactionDate ? `${baseId}-${transactionDate}` : baseId;
};
